// Action Types


// Action Creators
import * as actionTypes from "../ActionTypes";

// 🔹 Save
export const saveBulletinCoverImageRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_BULLETIN_COVERIMAGE_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});
export const saveBulletinCoverImageSuccess = (data) => ({
  type: actionTypes.SAVE_BULLETIN_COVERIMAGE_SUCCESS,
  payload: data,
});
export const saveBulletinCoverImageFailure = (error) => ({
  type: actionTypes.SAVE_BULLETIN_COVERIMAGE_FAILURE,
  payload: error,
});

// 🔹 Update
export const updateBulletinCoverImageRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_BULLETIN_COVERIMAGE_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});
export const updateBulletinCoverImageSuccess = (data) => ({
  type: actionTypes.UPDATE_BULLETIN_COVERIMAGE_SUCCESS,
  payload: data,
});
export const updateBulletinCoverImageFailure = (error) => ({
  type: actionTypes.UPDATE_BULLETIN_COVERIMAGE_FAILURE,
  payload: error,
});
export const deleteBulletinCoverImageRequest = ({ apiPayloadRequest, callback }) => ({
  type: actionTypes.DELETE_BULLETIN_COVERIMAGE_REQUEST,
  payload: { apiPayloadRequest, callback },
});

export const deleteBulletinCoverImageSuccess = (data) => ({
  type: actionTypes.DELETE_BULLETIN_COVERIMAGE_SUCCESS,
  payload: data,
});

export const deleteBulletinCoverImageFailure = (error) => ({
  type: actionTypes.DELETE_BULLETIN_COVERIMAGE_FAILURE,
  payload: error,
});